import React from 'react';
import { Box, Typography } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

export function CampaignFillingFastBadge() {
    const { themeStyle } = useThemeContext();
    const t = theme[themeStyle];

    return (
        <Box
            role="status"
            aria-label="Campaign filling fast"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                px: 1.5,
                py: 0.75,
                borderRadius: 999,
                background: `linear-gradient(135deg, rgba(255, 107, 53, 0.22) 0%, rgba(255, 193, 7, 0.14) 100%)`,
                border: '1px solid rgba(255, 140, 66, 0.45)',
                boxShadow: '0 0 24px rgba(255, 107, 53, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.12)',
                backdropFilter: 'blur(8px)',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 22,
                    height: 22,
                    borderRadius: '50%',
                    bgcolor: 'rgba(255, 107, 53, 0.2)',
                    color: '#FF8C42',
                    flexShrink: 0,
                }}>
                <LocalFireDepartmentIcon sx={{ fontSize: 14 }} />
            </Box>
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                    color: t.true_white,
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                }}>
                Filling fast
            </Typography>
        </Box>
    );
}
